import { render } from "./PaymentForm.vue?vue&type=template&id=308fb68a&bindings={\"errors\":\"setup\",\"capitalize\":\"setup\",\"userName\":\"setup\",\"schema\":\"setup\",\"submit\":\"setup\",\"console\":\"setup\",\"workbench\":\"setup\"}"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
script.render = render

export default script